import React from 'react';

import { Label } from '@eika/label';

import Labels from './Labels';

type Props = {
    title: React.ReactNode;
    description?: React.ReactNode;
    labels?: ReturnType<typeof Label>[] | ReturnType<typeof Label>;
};

const TextContent: React.FC<Props> = ({ title, description, labels }) => (
    <span className="sgw-link-list-item__text">
        <span className="sgw-link-list-item__text-first-row">
            <span>{title}</span>
            <span className="sgw-link-list-item__text-first-row__label">
                <Labels labels={labels} />
            </span>
        </span>
        <span className="sgw-link-list-item__description">{description}</span>
    </span>
);

export default TextContent;
